import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../cn";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid ? "true" : undefined}
      className={cn(
        "border-charcoal/20 bg-cream text-body text-charcoal h-11 w-full rounded-md border px-3 py-2",
        "placeholder:text-muted",
        "focus-visible:ring-saffron focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1",
        "disabled:cursor-not-allowed disabled:opacity-50",
        invalid && "border-terracotta focus-visible:ring-terracotta",
        className,
      )}
      {...rest}
    />
  );
});
